<template>
  <v-list class="sidebar" dense v-if="!currentUserData.loading">
    <template v-for="(item, key) in sidebar">
      <template v-if="item.route">
        <v-list-item :key="key" :to="item.route">
          <v-list-item-icon>
            <v-icon small v-if="item.icon">mdi-{{item.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <span>{{item.name}}</span>
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-if="item.children && item.children.length > 0">
        <v-list-group no-action :key="key">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon small v-if="item.icon">mdi-{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              <span>{{item.name}}</span>
            </v-list-item-title>
          </template>
          <template v-for="(child, i) in item.children" >
            <v-list-item :key="i" :to="child.route">
              <v-list-item-content>
                <v-list-item-title>{{child.name}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
      </template>
    </template>
  </v-list>
  <v-container v-else style="height: 100%">
    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
    >
      <v-col
        class="subtitle-1 text-center"
        cols="12"
      >
        Загрузка данных
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
.sidebar .v-list-item__title {
  color: rgba(194, 202, 214, 1);
  letter-spacing: 0;
  text-align: left;
}

.sidebar .v-list-item--active {
  background: #14191F!important;
}

.sidebar .v-list-item--active .v-list-item__title {
  color: rgba(255, 255, 255, 1);
}

.sidebar .theme--dark.v-list-item--active:before {
  opacity: 0!important;
}
</style>

<script>
export default {
  name: 'Sidebar',
  computed: {
    layout() {
      return this.$store.state.layout;
    },
    sidebar() {
      return this.$store.getters['account/getSidebarByRights'];
    },
    currentUserData() {
      return this.$store.state.account.user;
    },
  },
};
</script>

<style scoped>

</style>
